module.exports = __webpack_public_path__ + "f5dafaa5d5d3e0a765b7ae4b2295c9c6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-20.png
// module id = 2183
// module chunks = 0